import { Injectable } from '@angular/core'
import { UiStorageService } from '@helios/user-preferences'

export const RECON_DASHBOARD_PREFIX = `recon-dashboard`

@Injectable({
  providedIn: 'root',
})
export class ReconDashboardStorageService {
  private readonly userDashboardPrefix: Promise<string>

  constructor(private readonly storage: UiStorageService) {
    const base32User = storage.getBase32User()
    const clientId = storage.getClientId()
    this.userDashboardPrefix = Promise.all<string, number>([
      base32User,
      clientId,
    ]).then(
      userAndClient =>
        `${RECON_DASHBOARD_PREFIX}/${userAndClient[1]}/${userAndClient[0]}`,
    )
  }

  async getUserDashboardConfig(configId: string): Promise<string | undefined> {
    const userDashboardPrefix = await this.userDashboardPrefix
    return this.storage.getObject(`${userDashboardPrefix}/${configId}`, true)
  }

  async putUserDashboardConfig(
    configId: string,
    config: string,
  ): Promise<void> {
    const userDashboardPrefix = await this.userDashboardPrefix
    return this.storage.putObject(`${userDashboardPrefix}/${configId}`, config)
  }
}
